var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIconMissionH4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C2 13.255 15.88 0 33 0c17.12 0 31 13.255 31 29.607",
    fill: "#FFF0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65c-8.75 0-16.943-3.298-23.074-9.287a1.341 1.341 0 0 1-.033-1.88 1.3 1.3 0 0 1 1.854-.034c5.638 5.51 13.186 8.544 21.253 8.544 8.045 0 15.578-3.02 21.213-8.504a1.3 1.3 0 0 1 1.854.038c.502.53.486 1.372-.038 1.88C49.904 61.718 41.725 65 33 65",
    fill: "#F9B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.245 29.35-.173 3.62c3.784.186 6.75 3.34 6.75 7.18v18.79c1.172.15 2.365.237 3.577.26V40.15c0-5.777-4.46-10.522-10.154-10.8",
    fill: "#FCD6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.566 16.398c5.227-1.076 10.274.764 11.506 5.068 1.118 3.91-.574 7.082-4.765 10.108 4.066 4.021 4.203 9.61 1.377 12.969-2.99 3.554-9.4 3.388-13.87-.875-4.589-4.377-5.556-10.946-3.425-18.115 0 0 2.346-7.75 9.177-9.155",
    fill: "#F9B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.602 40.15V59.2a32.57 32.57 0 0 0 3.577-.261v-18.79c0-3.84 2.964-6.993 6.748-7.178l-.171-3.621c-5.695.278-10.154 5.022-10.154 10.8",
    fill: "#FCD6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.434 16.398c-5.227-1.076-10.274.764-11.506 5.068-1.118 3.91.574 7.082 4.765 10.108-4.066 4.021-4.203 9.61-1.377 12.969 2.99 3.554 9.4 3.388 13.87-.875 4.589-4.377 5.556-10.946 3.425-18.115 0 0-2.346-7.75-9.177-9.155",
    fill: "#F9B4B4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconMissionH4);
export default __webpack_public_path__ + "static/media/ic-icon-mission-h-4.e25e393e5fac9bbd8f360cf7d302c295.svg";
export { ForwardRef as ReactComponent };